export const hasClass = (element, className) => {
    return element.classList.contains(className)
}

export const closest = (element, className) => {
    return element.closest(className)
}
